import { createService } from 'reservice'
import {
  FETCH_SE_COOKIE
} from '../actionTypes'

export const fetchSeCookie = createService(FETCH_SE_COOKIE)
